module.exports = __webpack_public_path__ + "img/farzana-christopher-148.60335c62.jpg";